<template >
  <div class="leftPanel">
    <div class="lawyer-box">
      <div class="lawyer-title">律师列表（共{{ total }}人 每页10条）</div>
      <div v-if="total !== 0" v-loading="lawyerLoading" class="lawyers-container">
        <div class="lawyers">
          <div v-for="lawyer in lawyers" :key="lawyer.id" :class="['lawyer-item', currLawyer.id === lawyer.id ? 'active' : '']">
            <div class="lawyer-item-left-box">
              <!-- <img src="@/assets/image/lawyer.png" /> -->
              <el-image :src="imgPath(lawyer.name)" style="height: 60px;border-radius: 50%"  >
                <div slot="error">
                  <img
                      src="avatar/0.png"
                      style="width: 6px;"
                  />
                </div>
              </el-image>
            </div>
            <div class="lawyer-item-top-right">
              <div class="lawyer-item-name" :title="lawyer.name">{{ lawyer.name }}</div>
              <div class="lawyer-item-state-country">
                <div class="lawyer-item-state">地区：{{ lawyer.state }}</div>
                &nbsp;&nbsp;&nbsp;
                <div class="lawyer-item-country">国家：{{ lawyer.country }}</div>
              </div>
              <div class="lawyer-item-org">机构：{{ lawyer.org }}</div>
              <div class="lawyer-item-position">职务：{{ lawyer.position }}</div>
              <div class="lawyer-item-icon">
                <i class="icon iconfont-system dingwei" title="定位" @click="doLocation(lawyer)">定位</i>
                &nbsp;&nbsp;
                <i class="icon iconfont-system wenjian" title="详情" @click="viewDetail(lawyer)" >详情</i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="lawyers-container" style="text-align: center; color: #bbb;">无数据</div>
      <div v-if="total !== 0" class="lawyers-page-bar">
        <el-pagination
          class="page-container"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="total"
          :pager-count="7"
          :align="'left'"
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
      <div v-else class="lawyers-page-bar">&nbsp;</div>
    </div>
  </div>
  <!-- .leftPanel(:class="{hidden: isHideLeft}" )
    .hidden-button(@click="hideLeft()")
      img(:src="require(`@/assets/leftPanel/arrow-${arrowImg}.svg`)" style="width: 14px;")
    .title-box
    .content
        component(:is='curMenu' v-if="curMenu") -->

</template>

<script>
//import SiteInfo from '@/components/leftPanel/SiteInfo'

import olUtils from '@/scripts/olBasicUtils'

import { mapState, mapMutations } from 'vuex'
export default {
  name: 'leftPanel',
  components: {
    //SiteInfo
  },
  computed: {
    ...mapState({ // 这里的...是超引用，ES6的语法，意思是state里有多少属性值我可以在这里放多少属性值
      //curMenu: state => state.pageStatus.curMenuName,
      isHideLeft: state => state.pageStatus.isHideLeft
    })
  },
  data () {
    return {
      curContent: '',
      isHide: true,
      arrowImg: 'right',
      imgurl:'avatar/',
      jpg:'.jpg' 
    }
  },
  watch: {
    // 隐藏
    isHideLeft (newV) {
      this.arrowImg = newV ? 'right' : 'left'
      if (newV) return olUtils.PanByPixel(-240, 0)
      olUtils.PanByPixel(240, 0)
    },
    // 组件变化时
    curMenu () {
      this.leftPanelHide(false)
    }
  },
  mounted () {

  },
  computed:{
      imgPath(name) {
      return "avatar/" + name + ".jpg";
    }
    },
  methods: {
    ...mapMutations('pageStatus', [
      'leftPanelHide'
    ]),
    // 隐藏按钮
    hideLeft () {
      this.leftPanelHide(!this.isHideLeft)
      if (this.isHideLeft) {
        // 收起
        olUtils.PanByPixel(-240, 0)
      } else {
        // 打开
        olUtils.PanByPixel(240, 0)
      }
    }

  }
}
</script>

<style lang="less" scoped>
.leftPanel{
  top: 0;
  left: 0;
  transition: all ease-in-out 0.4s;   
}
.lawyer-box {
  position: fixed;
  left: 0;
  width: 360px;
  height: calc(100% - 46px);
  background: rgb(255, 255, 255);
  border-right: solid 1px #ccc;
  .lawyer-title {
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 5px;
    background: #eee;
    // box-shadow: 0 2px 5px #777;
    // border: solid 1px #ccc;
    // border-radius: 0 5px 0 0;
  }
  .lawyers-container {
    padding: 5px;
    width: calc(100% - 10px);
    height: calc(100% - 90px);
    overflow: auto;
    .lawyers {
      width: 100%;
      .lawyer-item {
        display: flex;
        flex-direction: row;
        width: calc(100% - 10px);
        // height: 100px;
        border: outset 1px #e3d0ab;;
        border-radius: 5px;
        margin-bottom: 5px;
        padding: 5px;
        font-size: 12px;
        cursor: pointer;
        &:hover {
          background: #f5f4c1;
        }
        .lawyer-item-left-box {
          width: 60px;
          height: calc(100%);
          img {
            width: 60px;
            height: 60px;
          }
        }
        .lawyer-item-top-right {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding-left: 20px;
          .lawyer-item-name {
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            width: 300px;
            white-space: nowrap; /* 禁止换行 */
            overflow: hidden; /* 超出长度隐藏 */
            text-overflow: ellipsis; /* 显示省略号 */
          }
          .lawyer-item-state-country {
            display: flex;
            flex-direction: row;
          }
          .lawyer-item-state-country, .lawyer-item-org {
            // height: 23px;
            line-height: 23px;
            width: calc(100%);
          }
          .lawyer-item-position {
            flex: 1;
            width: calc(100%);
          }
          .lawyer-item-icon {
            width: calc(100%);
            height: 23px;
            line-height: 23px;
            text-align: right;
            i {
              font-size: 14px;
              &:hover {
                color: blue;
                font-weight: bold;
                font-size: 14px;
              }
            }
          }
        }
      }
      .active {
        background: #f5f4c1;
      }
    }
  }
  .lawyers-page-bar {
    border-top: solid 1px #eee;
    // box-shadow: 0 0 8px #777;
    height: 40px;
    line-height: 40px;
  }
}

</style>
